import { render, staticRenderFns } from "./AttestationTab.vue?vue&type=template&id=7d07850e"
import script from "./AttestationTab.vue?vue&type=script&lang=js"
export * from "./AttestationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports